import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Building2,
  BookOpen,
  ClipboardCheck,
  FileText,
  Scale,
  Users2,
  AlertTriangle,
  Settings,
  LogOut,
} from 'lucide-react';
import useAuthStore from '../store/authStore';

const Sidebar = ({ isOpen, onClose }) => {
  const { user, logout } = useAuthStore();

  const navigation = [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: LayoutDashboard,
      roles: ['superadmin', 'admin_org', 'miembro'],
    },
    {
      name: 'Usuarios',
      href: '/usuarios',
      icon: Users,
      roles: ['superadmin', 'admin_org'],
    },
    {
      name: 'Organizaciones',
      href: '/organizaciones',
      icon: Building2,
      roles: ['superadmin'],
    },
    {
      name: 'Glosario',
      href: '/glosario',
      icon: BookOpen,
      roles: ['superadmin', 'admin_org', 'miembro'],
    },
    {
      name: 'Lista de Chequeo',
      href: '/chequeo',
      icon: ClipboardCheck,
      roles: ['superadmin', 'admin_org'],
    },
    {
      name: 'Encuestas',
      href: '/encuestas',
      icon: FileText,
      roles: ['superadmin', 'admin_org', 'miembro'],
    },
    {
      name: 'Plantilla Encuesta',
      href: '/encuestas/plantilla',
      icon: Settings,
      roles: ['superadmin'],
    },
    {
      name: 'Códigos de Ética',
      href: '/codigos',
      icon: Scale,
      roles: ['superadmin', 'admin_org', 'miembro'],
    },
    {
      name: 'Comité de Ética',
      href: '/comite',
      icon: Users2,
      roles: ['superadmin', 'admin_org'],
    },
    {
      name: 'Denuncias',
      href: '/denuncias',
      icon: AlertTriangle,
      roles: ['superadmin', 'admin_org', 'miembro'],
    },
  ];

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  // Filtrar navegación según rol
  const filteredNavigation = navigation.filter(item =>
    item.roles.includes(user?.rol)
  );

  return (
    <>
      {/* Overlay para móvil */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-20 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className={`
          fixed inset-y-0 left-0 z-30 w-64 bg-gray-900 transform transition-transform duration-300 ease-in-out
          lg:translate-x-0 lg:static lg:inset-0
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center justify-center h-16 px-4 bg-gray-800">
            <div className="flex items-center">
              <div className="h-10 w-10 bg-primary-600 rounded-full flex items-center justify-center">
                <span className="text-xl font-bold text-white">M</span>
              </div>
              <span className="ml-2 text-white font-semibold text-lg">
                MED
              </span>
            </div>
          </div>

          {/* User Info */}
          <div className="px-4 py-4 bg-gray-800 border-b border-gray-700">
            <div className="flex items-center">
              <div className="h-10 w-10 rounded-full bg-primary-600 flex items-center justify-center">
                <span className="text-white font-semibold">
                  {user?.nombre_completo?.charAt(0).toUpperCase()}
                </span>
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-white truncate">
                  {user?.nombre_completo}
                </p>
                <p className="text-xs text-gray-400 capitalize">
                  {user?.rol?.replace('_', ' ')}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
            {filteredNavigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${
                    isActive
                      ? 'bg-primary-600 text-white'
                      : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                  }`
                }
                onClick={() => {
                  if (window.innerWidth < 1024) {
                    onClose();
                  }
                }}
              >
                <item.icon className="mr-3 h-5 w-5" />
                {item.name}
              </NavLink>
            ))}
          </nav>

          {/* Footer */}
          <div className="px-2 py-4 bg-gray-800 border-t border-gray-700 space-y-1">
            <NavLink
              to="/configuracion"
              className="flex items-center px-4 py-3 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors duration-200"
            >
              <Settings className="mr-3 h-5 w-5" />
              Configuración
            </NavLink>

            <button
              onClick={handleLogout}
              className="w-full flex items-center px-4 py-3 text-sm font-medium text-gray-300 hover:bg-red-600 hover:text-white rounded-lg transition-colors duration-200"
            >
              <LogOut className="mr-3 h-5 w-5" />
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
